import { MagnifyExpandIcon } from './MagnifyExpandIcon';

/**
 * author: snis
 * id D6842910-49FD-4F74-8D67-86865549097A
 * name magnify-expand
 * version: 6.2.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/magnify-expand.svg
 * tags
 * - Geographic Information System 
 */
export const SearchExpandIcon = MagnifyExpandIcon;
export default SearchExpandIcon